<!--
 * @Descripttion: 申请样品业务组件，支持快速申样及批量申样
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:15:33
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-11 18:27:36
-->
<template>
	<el-drawer :title="title" :visible.sync="visible" class="apply-sample-drawer" :before-close="handleClose" size="1100px" :wrapperClosable="false">
		<!-- 抽屉内容 -->
		<div class="content" v-if="visible">
			<!-- 顶部锚点 -->
			<div class="bgcf top pt-12 pr-16 pb-12 pl-20">
				<topAnchors></topAnchors>
			</div>

			<!-- 选择合作对象 -->
			<div class="bgcf">
				<ChooseCooPartner
					:isCommander="isCommander"
					class="choose-coo-partner"
					ref="chooseCooPartner"
					@getList="getList($event)"
					:platformId="platformId"
				></ChooseCooPartner>
			</div>

			<!-- 确认合作商品 -->
			<div class="bgcf">
				<ConfirmCooGoods
					ref="confirmCooGoods"
					:isBatch="isBatch"
					class="confirm-coo-goods"
					:platformId="platformId"
					:chooseGoodsList="chooseGoodsList"
					:total="total"
				></ConfirmCooGoods>
			</div>

			<!-- 确认合作约定 -->
			<div class="bgcf">
				<ConfirmAppoint class="confirm-appoint" ref="confirmAppoint" @change="setAppointParams" :platformId="platformId"></ConfirmAppoint>
			</div>
			<div style="height: 38px"></div>
		</div>
		<!-- 底部按钮组 -->
		<div class="footer yx-background-white">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="confirm" :disabled="isDisable" :loading="loading">确认申样</el-button>
		</div>
		<closeTip ref="closeTip" @colse="colse"></closeTip>
		<batchHintDialog ref="batchHintDialog" @sampleOrderBatchApply="sampleOrderBatchApply" @reset="resetLoading" />
	</el-drawer>
</template>
<script>
import debounce from 'lodash/debounce';
import topAnchors from './components/topAnchors';
import { getProductSkuList, directBatchAdd, checkSendSampleOrder, syncProductSkuList } from '@/api/shopManage';
import ConfirmAppoint from './components/confirmAppoint';
import ConfirmCooGoods from './components/confirmCooGoods';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	name: 'AppleSampleDrawer',
	components: {
		ChooseCooPartner: () => import('./components/chooseCooPartner'),
		ConfirmCooGoods,
		closeTip: () => import('./components/closeTip'),
		batchHintDialog: () => import('./components/errorDialog/batchHintDialog.vue'),
		topAnchors,
		ConfirmAppoint,
	},
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	data() {
		return {
			visible: false, // 抽屉显隐
			mode: 'fast', // 模式，fast为快速申样，multiple为批量申样
			goods: [], // 申样商品
			productIds: [],
			total: 0,
			chooseGoodsList: [],
			appointParams: {},
			anchorObj: {},
			loading: false,
			productList: [],
			isCommander: false,
			selectionShopArr: [],
		};
	},
	computed: {
		isBatch({ mode }) {
			return mode === 'multiple';
		},
		title({ isBatch }) {
			return isBatch ? '批量申样' : '快速申样';
		},
		isDisable({ anchorObj }) {
			return !anchorObj.isChecked;
		},
	},
	methods: {
		async show(selectionShopArr, mode = 'multiple', isCommander) {
			this.selectionShopArr = selectionShopArr;
			this.isCommander = isCommander;
			if (!['fast', 'multiple'].includes(mode)) {
				throw new Error('申样组件模式只能为fast或者mutilple');
			}
			this.mode = mode;
			this.productIds = selectionShopArr.map(item => item.product_id);
			this.visible = true;
			await this.asyncSkuList();
			this.getSkuList();
		},
		async getSkuList() {
			const { platformId, productIds } = this;
			const list = await getProductSkuList({ platformId, productIds });
			// 数组去重
			let arr = [
				...list.map(item => {
					return {
						...item,
						hasSku: true,
					};
				}),
				...this.selectionShopArr.map(item => {
					return {
						productName: item.product_name,
						productPic: item.product_pic,
						shopName: item.shop_name,
						productId: item.product_id,
						thirdProductId: item.third_product_id,
						id: '',
						onlyId: '',
						price: item.sale_price,
						skuId: '',
						sourceType: '',
						sourceTypeDesc: '',
						specification: '',
						spuPrice: item.sale_price,
						stockNum: '',
						hasSku: false,
					};
				}),
			];
			let map = new Map();
			for (let item of arr) {
				if (!map.has(item.productId)) {
					map.set(item.productId, item);
				}
			}
			this.chooseGoodsList = [...map.values()];
			this.visible = true;
		},
		async asyncSkuList() {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku
			const productIds = this.selectionShopArr.map(item => ({
				outProductId: item.third_product_id,
				productId: item.product_id,
			}));
			await syncProductSkuList({
				platformId: this.platformId,
				productIds,
				source: dataMap.syncSkuSource.apply_sample,
			});
		},
		getList(params) {
			this.anchorObj = params;
		},
		resetLoading() {
			this.loading = false;
		},
		colse() {
			(this.m1 = 0), (this.m2 = 0), (this.m3 = 0), (this.chooseGoodsList = []);
			this.isCommander = false;
			this.loading = false;
			this.selectionShopArr = [];
			this.anchorObj = {};
			this.productList = [];
			this.$refs.confirmCooGoods.reset();
			this.visible = false;
		},
		handleClose() {
			this.colse();
		},
		setAppointParams(e) {
			this.appointParams = e;
		},
		async checkSendSample() {
			const { anchorObj, productList } = this;
			const productIds = productList.map(item => item.productId);
			const anchorIds = anchorObj.anchorList.map(item => item.anchorId);
			const retailType = anchorObj.retailType;
			const teamInstitutionIds = anchorObj.retailType ? anchorObj.anchorList.map(item => item.teamInstitutionId) : undefined;
			const { code: code1, data: { type, status, partners = [], productInfos = [], team_institution_infos = [] } = {} } = await checkSendSampleOrder({
				productIds,
				anchorIds,
				retailType,
				teamInstitutionIds,
			});
			if (code1 !== 0) return (this.loading = false);
			if (!type) return this.sampleOrderBatchApply();
			let list = [...partners, ...productInfos];
			this.$refs.batchHintDialog.show(list, type, retailType);
		},
		confirm: debounce(async function () {
			this.loading = true;
			const goodsSpuObj = this.$refs.confirmCooGoods.getSelectList();
			this.productList = Object.keys(goodsSpuObj).map(productId => {
				const skus = goodsSpuObj[productId];
				const { thirdProductId } = skus[0];
				const { specificationRemark } = skus[0];
				const skuList = skus.map(sku => ({ outerSkuId: sku.skuId, skuId: sku.id, num: sku.nums || 0 }))?.filter(v => v.skuId);
				return { thirdProductId, productId, skuList, specificationRemark };
			});
			this.checkSendSample();
		}, 1000),
		async sampleOrderBatchApply(preCheckFlag = true) {
			const { platformId, appointParams, anchorObj, productList } = this;
			try {
				const { code, data } = await directBatchAdd({ productList, ...anchorObj, ...appointParams, platformId, preCheckFlag });
				if (code !== 0) {
					this.loading = false;
					return;
				}
				this.loading = false;
				if (data.code) {
					this.$refs.batchHintDialog.show(data.errorData, data.code);
				} else {
					this.$message({ type: 'success', message: '申样成功！', offset: 50 });
					this.$emit('refreshList');
					this.handleClose();
				}
			} catch (e) {
				this.loading = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.apply-sample-drawer {
	.content {
		position: relative;
		padding: 0px 20px 16px 20px;
		background-color: @color-gy2;
		.bgcf {
			padding: 20px 20px;
			background-color: @color-white;
			border-radius: 4px;
			margin-bottom: 16px;
		}
		.top {
			margin-bottom: 0px;
			/* 兼容chorme */
			position: -webkit-sticky;
			position: sticky;
			top: 0px;
			border-top: 16px solid @color-gy2;
			border-bottom: 16px solid @color-gy2;
			z-index: 999;
		}
	}
	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid @color-gy3;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}
	/deep/ .el-table__empty-block {
		display: none;
	}
}
</style>
